import { types } from "mobx-state-tree";
import { createContext, useContext } from "react";

import {
  createMarketPlaceStore,
  MarketPlaceStore,
} from "stores/marketPlaceStore";
import { createPageStore, PageStore } from "stores/pageStore";
import { createUserStore, UserStore } from "stores/userStore";
import { createOrgStore, OrgStore } from "stores/orgStore";

const RootStore = types.model("RootStore", {
  marketPlaceStore: MarketPlaceStore,
  pageStore: PageStore,
  userStore: UserStore,
  orgStore: OrgStore,
});

export const createRootStore = () => {
  const marketPlaceStore = createMarketPlaceStore();
  const pageStore = createPageStore();
  const userStore = createUserStore();
  const orgStore = createOrgStore();
  return RootStore.create({ marketPlaceStore, pageStore, userStore, orgStore });
};

type TRootStore = ReturnType<typeof createRootStore>;
const RootStoreContext = createContext<TRootStore>({} as TRootStore);

export const RootStoreProvider = RootStoreContext.Provider;
export const useStores = () => useContext(RootStoreContext);
